export enum EVENT_ITEM_LABEL {
  WATCH_TRAILER = 'watch_trailer',
}

export enum ABOUT_PAGE_EVENT_NAMES {
  ABOUT_CAROUSEL_ITEM_CLICK = 'about-carousel-item-click',
  ABOUT_ITEM_CLICK = 'about-item-click',
}
